import {
    ADMIN_SETUP_DOWNLOADED_CSV_FILE_NAME,
    ASCENDING_ORDER,
    AUTH_COOKIE,
    DASHBOARD_TREE,
    LOGIN_AS, LOGIN_ATTEMPT_API,
    NO_DATA_TO_SHOW,
    SIGN_OUT_API,
    SUCCESS_STATUS,
    USER_INFO_API,
    USER,
    YYYY_MM_DD_H_MM_SS_A_DATEFORMAT,
} from "../api/constants";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";
import { ProgressBar } from "react-bootstrap";
import { UDX } from "./UDX";
import React from "react";

// Create a custom axios instance with withCredentials enabled
export const semcastAxios = (() => {
    const semcastAxiosInstance = axios.create({
        withCredentials: true, // Let the browser handle cookies automatically
    });
    semcastAxiosInstance.interceptors.request.use((config) => {
        if (
            window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1"
        ) {
            // Removed the manual "Cookie" header setting:
            // config.headers["Cookie"] = getAuthCookieFromStorage();
            config.headers["Content-Type"] = "text/plain";
        }
        return config;
    });
    semcastAxiosInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error?.response?.status === 401) {
                const hasClientSession = isUserLoggedIn() || Boolean(sessionStorage.getItem(USER));
                const shouldForceLogout = Boolean(error?.response?.data?.forcedLogout);
                const logoutReason = error?.response?.data?.logoutReason;

                if (hasClientSession && shouldForceLogout) {
                    forceClientSignOutWithReason(logoutReason || "Your session was ended because your account is no longer active. If this is a mistake, please file a ticket with support@semcastingactivate.freshdesk.com.");
                    return Promise.reject(error);
                }
            }

            return Promise.reject(error);
        }
    );
    return semcastAxiosInstance;
})();

export const forceClientSignOutWithReason = (reason) => {
    const loggedInFromToolbox = sessionStorage.getItem("isToolboxLogged");
    if (reason) {
        localStorage.setItem("forcedLogoutReason", reason);
    }
    removeDataFromStorage();
    const nextUrl = loggedInFromToolbox
        ? "/identitytoolbox?sessionexp=true"
        : "/?sessionexp=true";
    if (window.location.pathname + window.location.search !== nextUrl) {
        window.location.href = nextUrl;
    }
};


export const getUser = () => {
    const userId = sessionStorage.getItem("userId");
    if (userId) return userId;
    else return null;
};

// return the isLogged from the session storage
export const isUserLoggedIn = () => {
    return sessionStorage.getItem("isLogged") ? true : false;
};

// remove the isLogged and userId from the session storage
export const removeDataFromStorage = () => {
    sessionStorage.clear();
    //sessionStorage.removeItem("isLogged");
    //sessionStorage.removeItem("userId");
};

// set the isLogged and userId from the session storage
export const setDataToStorage = (isLogged, userId) => {
    sessionStorage.setItem("isLogged", isLogged);
    sessionStorage.setItem("userId", userId);
};

export const setAuthCookieToStorage = (authCookie) => {
    sessionStorage.setItem(AUTH_COOKIE, authCookie);
};

export const getAuthCookieFromStorage = () => {
    return sessionStorage.getItem(AUTH_COOKIE);
};

export const setUserDataToStorage = (user) => {
    sessionStorage.setItem(USER, JSON.stringify(user));
};

export const getUserDataFromStorage = () => {
    return sessionStorage.getItem(USER);
};

// extract "auth" cookie from response
export const extractAuthCookie = () => {
    try {
        let name = AUTH_COOKIE + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
    } catch (e) {
    }
    return "";
};

export const getAuthCookieHeader = () => {
    return window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
        ? {
            Cookie: getAuthCookieFromStorage(),
            "Content-Type": "text/plain",
        }
        : {};
};

export const showSuccessToastMessage = (message, time, onClose) => {
    if (time == null) time = 5;

    let toastOptions = {
        position: "top-right",
        autoClose: time * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    }
    if (onClose) {
        toastOptions.onClose = onClose;
    }

    toast.success(message, toastOptions);
};
export const showErrorToastMessage = (message, time) => {
    // if(toast.isActive("LogInErrorMsg")) {
    //     await toast.dismiss("LogInErrorMsg");
    // };

    if (time == null) time = 5;

    toast.error(message, {
        toastId: "LogInErrorMsg",
        position: "top-right",
        autoClose: time * 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};
export const showToastMessage = (message, type = "success") => {
    if (type && type.toLowerCase() === "success") {
        showSuccessToastMessage(message);
    } else if (type && type.toLowerCase() === "error") {
        showErrorToastMessage(message);
    }
};

export const hideNShow = (e, show = false) => {
    e.target.style.display = show ? "none" : "block";
};
let location_properties_list = [];
export const handleCheckboxChange = async (
    e,
    formikField,
    formik,
    activateFormBase
) => {
    const {checked, name} = e.target;
    if (checked === true && !formik.values[formikField].includes(name)) {
        formik.setFieldValue(formikField, [...formik.values[formikField], name]);
    } else if (checked === false && formik.values[formikField].includes(name)) {
        formik.setFieldValue(
            formikField,
            formik.values[formikField].filter((v) => v !== name)
        );
    }
    //Activation Measurement tile rules
    //Using a list to update fieldvalue because formik is updated async
   if(activateFormBase.company === "semcastingmeasurement"){

       if (checked) {
           location_properties_list.push(name)
       if(name === 'consumer_pii' && location_properties_list.includes('consumer_basics')){
                   location_properties_list = location_properties_list.filter(function(item) {
                       return item !== 'consumer_basics'
                   })
           formik.setFieldValue(formikField, location_properties_list);
           }else if(name === 'consumer_basics' && location_properties_list.includes('consumer_pii')){
           location_properties_list = location_properties_list.filter(function(item) {
               return item !== 'consumer_pii' && item !== 'consumer_demographics'
           })
           formik.setFieldValue(formikField, location_properties_list);
       } else if(name === 'consumer_demographics' && location_properties_list.includes('consumer_basics')){
           location_properties_list = location_properties_list.filter(function(item) {
               return item !== 'consumer_basics'
           })
           formik.setFieldValue(formikField, location_properties_list);
       } else if(name === 'consumer_basics' && location_properties_list.includes('consumer_demographics')) {
           location_properties_list = location_properties_list.filter(function(item) {
               return item !== 'consumer_demographics'
           })
           formik.setFieldValue(formikField, location_properties_list);
       }
       } else if (checked === false) {
           location_properties_list = location_properties_list.filter(function(item) {
               return item !== name
           })
           formik.setFieldValue(
               formikField,
               formik.values[formikField].filter((v) => v !== name)
           );
       }

   }
};
let trending_list = [];
export const handleTrendingCheckboxChange = async (
    e,
    formikField,
    formik,
    segmentData
) => {
    const {checked, name} = e.target;

    // Number formatter.
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    if (checked) {
        await formik.setFieldValue(formikField, [...formik.values[formikField], name]);
        trending_list.push(name);
    } else {
        await formik.setFieldValue(
            formikField,
            formik.values[formikField].filter((v) => v !== name)
        );

        trending_list = trending_list.filter(function(item) {
            return item !== name
        })
    }
    let t = Math.max(segmentData.total_businesses, segmentData.total_households)
    let c = trending_list.length;
    let n = formatter.format(Math.max((t * c) * .0005, c * 10.00));
    formik.setFieldValue('calculated_cost', n,true);
    document.getElementById('calculated_cost').value = n;

};
export const handleDropDownChange = (
    e,
    formikField,
    formik
) => {
    if (e.target.value) {
        formik.setFieldValue(formikField, e.target.value.val);
    }
};

export const handleDatePickerStartDateChange = (
    e,
   props
) => {
    if (e.target.value) {
        props.formik.setFieldValue("campaign_range_start", e.target.value.toISOString().split('T')[0]);
    }else{
        props.formik.setFieldValue("campaign_range_start", "");
    }
};
export const handleDatePickerEndDateChange = (
    e,
   props
) => {
    if (e.target.value) {
        props.formik.setFieldValue("campaign_range_end", e.target.value.toISOString().split('T')[0]);

    }else{
        props.formik.setFieldValue("campaign_range_end", "");
    }
};
export const handleDropDownChangeSemcastingXandr = (
    e,
    formikField,
    formik
) => {
    if (e.target.value) {
        let val = e.target.value.id.toString();
        formik.setFieldValue(formikField, val);
    }
};

// export const handlePinterestAccessChange = (
//   e,
//   formikField,
//   formik
// ) => {
// console.log("handle access", e.target.value);
//   window.addEventListener("message", (event)=>{
//     console.log(event.data)
//     formik.setFieldValue(formikField,event.data);
// Normally you would check event.origin
// To verify the targetOrigin matches
// this window's domain
// let token=document.getElementById("accessToken")
// event.data contains the message sent
// token.value=event.data;

// });
//   formik.setFieldTouched(formikField, true);
// formik.setFieldValue(formikField, document.getElementById("accessToken").value);
// };

export const handlePinterestAccessClick = (
    e,
    formikField,
    formik
) => {

    function OpenWindow() {
        const height = 850;
        const width = 350;
        const top = window.innerHeight - height;
        const left = window.innerHeight - width;
        window.open(
            "https://www.pinterest.com/oauth/?client_id=1482772&redirect_uri=https://ads-demo.semcasting.internal/segmentation-dashboard&response_type=code&scope=ads:read,ads:write&state=",
            'myWindow',
            'location=yes,height=' + height + ',width=' + width + ',top=' + top + ',left=' + left + ',scrollbars=yes,status=yes'
        );
    }

    OpenWindow();

    window.addEventListener("message", (event) => {
        formik.setFieldValue(formikField, event.data);
    });
};
//Handle Google Ads Access Code
export const handleGrantAccessClick = ( e, formikField, formik, activateFormBase) => {
    // console.log(activateFormBase.segment.id)
    // This is needed for the redirectUri and will vary by active environment.
    let origin = window.location.origin;
    if (activateFormBase.company === 'googleads') {
        const {protocol, hostname, port} = window.location;
        const origin = window.location.origin;
        const altHostname = hostname === "localhost" ? "127.0.0.1" : (hostname === "127.0.0.1" ? "localhost" : null);
        const altOrigin = altHostname ? `${protocol}//${altHostname}${port ? `:${port}` : ""}` : null;
        const messageHandler = (event) => {
            if (event.origin !== origin && (!altOrigin || event.origin !== altOrigin)) return;
            const data = event.data || {};
            if (data.type !== "googleads_auth") return;
            window.removeEventListener("message", messageHandler);
            formik.setFieldTouched(formikField, true, false);
            if (data.status === "success") {
                formik.setFieldValue(formikField, "granted");
                formik.setFieldError(formikField, undefined);
            } else {
                formik.setFieldValue(formikField, "");
                formik.setFieldError(formikField, "Access is required");
            }
        };
        window.addEventListener("message", messageHandler);

        let clientId = '483500096558-71jkff1220j3jckc27skju3c7fmpiqvl.apps.googleusercontent.com';
        // NOTE: Google does not allow localhost
        let googleAdsOrigin = (origin === 'http://localhost:8080' ? ('http://127.0.0.1:8080') : (origin)); // BKR This is a necessary hack.
        let redirectUri = encodeURIComponent(googleAdsOrigin + '/google/callback');
        let scope = encodeURIComponent('https://www.googleapis.com/auth/adwords');
        let state = activateFormBase.segment.id;
        let authUrl = 'https://accounts.google.com/o/oauth2/v2/auth?client_id=' + clientId +
            '&redirect_uri=' + redirectUri +
            '&response_type=code' +
            '&scope=' + scope +
            '&include_granted_scopes=true' +
            '&access_type=offline' +
            '&prompt=consent' +
            '&state=' + state;
        const windowFeatures = "left=100,top=100,width=500,height=800";
        const popup = window.open(authUrl, "GoogleAdsAuthenticate", windowFeatures);
        const pollTimer = setInterval(() => {
            if (!popup || popup.closed) {
                clearInterval(pollTimer);
                if (!formik.values[formikField]) {
                    formik.setFieldTouched(formikField, true, false);
                    formik.setFieldError(formikField, "Access is required");
                }
            }
        }, 500);
    }
    // PINTEREST

 else if (activateFormBase.company === 'pinterest') {
        let clientId = '1482772';
    // NOTE: Pinterest does not allow 127.0.0.1
        let redirectUri = encodeURIComponent(origin + '/pinterest/callback');
        let scope = encodeURIComponent('ads:read,ads:write');
        let state = activateFormBase.segment.id;
        let authUrl = 'https://www.pinterest.com/oauth/?client_id=' + clientId +
        '&redirect_uri=' + redirectUri +
        '&response_type=code' +
        '&scope=' + scope +
        '&state=' + state;
    const windowFeatures = "left=100,top=100,width=500,height=800";
    window.open(authUrl, "PinterestAuthenticate", windowFeatures);

    // TIKTOK

} else if (activateFormBase.company === 'tiktok') {
        const {protocol, hostname, port} = window.location;
        const origin = window.location.origin;
        const altHostname = hostname === "localhost" ? "127.0.0.1" : (hostname === "127.0.0.1" ? "localhost" : null);
        const altOrigin = altHostname ? `${protocol}//${altHostname}${port ? `:${port}` : ""}` : null;
        const messageHandler = (event) => {
            if (event.origin !== origin && (!altOrigin || event.origin !== altOrigin)) return;
            const data = event.data || {};
            if (data.type !== "tiktok_auth") return;
            window.removeEventListener("message", messageHandler);
            formik.setFieldTouched(formikField, true, false);
            if (data.status === "success") {
                formik.setFieldValue(formikField, "granted");
                formik.setFieldError(formikField, undefined);
            } else {
                formik.setFieldValue(formikField, "");
                formik.setFieldError(formikField, "Access is required");
            }
        };
        window.addEventListener("message", messageHandler);

        let appId = '7260405326367686657';
        let state = activateFormBase.segment.id;
        let redirectUri = encodeURIComponent(origin + '/tiktok/callback');
        let rid = 'jfgvkek0avn';
        let authUrl = 'https://ads.tiktok.com/marketing_api/auth' +
            '?app_id=' + appId +
            '&state=' + state +
            '&redirect_uri=' + redirectUri +
            '&rid=' + rid;
        const windowFeatures = "left=100,top=100,width=500,height=800";
        const popup = window.open(authUrl, "TikTikAuthenticate", windowFeatures);
        const pollTimer = setInterval(() => {
            if (!popup || popup.closed) {
                clearInterval(pollTimer);
                if (!formik.values[formikField]) {
                    formik.setFieldTouched(formikField, true, false);
                    formik.setFieldError(formikField, "Access is required");
                }
            }
        }, 500);
    } else if (activateFormBase.company === 'snapchat') {
        const {protocol, hostname, port} = window.location;
        const origin = window.location.origin;
        const altHostname = hostname === "localhost" ? "127.0.0.1" : (hostname === "127.0.0.1" ? "localhost" : null);
        const altOrigin = altHostname ? `${protocol}//${altHostname}${port ? `:${port}` : ""}` : null;
        const messageHandler = (event) => {
            if (event.origin !== origin && (!altOrigin || event.origin !== altOrigin)) return;
            const data = event.data || {};
            if (data.type !== "snapchat_auth") return;
            window.removeEventListener("message", messageHandler);
            formik.setFieldTouched(formikField, true, false);
            if (data.status === "success") {
                formik.setFieldValue(formikField, "granted");
                formik.setFieldError(formikField, undefined);
            } else {
                formik.setFieldValue(formikField, "");
                formik.setFieldError(formikField, "Access is required");
            }
        };
        window.addEventListener("message", messageHandler);

        let snapchatOrigin = (origin === 'https://localhost:8443' ? ('https://127.0.0.1:8443') : (origin));
        // Snapchat has separate creds for each callback url.  Here we have 2 set up (dev / prod)
        // Snapchat also expects HTTPS
        let env = snapchatOrigin === "https://audiencedesigner.com" ? "PROD" : "DEV";
        let clientId = env === "PROD" ? "a9ce1bdc-6210-4f5f-9376-9893c7c85211" : "823975f4-1248-48f0-b9ee-d3f110694a99";
        let state = activateFormBase.segment.id + "|" + env;
        let redirectUri = encodeURIComponent(snapchatOrigin + '/snapchat/oauth/callback');
        let authUrl = 'https://accounts.snapchat.com/v2/oauth2/authorize' +
            '?client_id=' + clientId +
            '&state=' + state +
            '&response_type=code' +
            '&redirect_uri=' + redirectUri +
            '&scope=snapchat-marketing-api';
        // let authUrl1 = "https://accounts.snapchat.com/v2/oauth2/authorize?client_id=823975f4-1248-48f0-b9ee-d3f110694a99&state=wmKkg0TWgppW8PTBZ20sldUmF7hwvU&response_type=code&redirect_uri=https%3A%2F%2F127.0.0.1%3A8443%2Fsnapchat%2Foauth%2Fcallback&scope=snapchat-marketing-api";
        // console.log("AUTH:"+authUrl);
        // console.log("AUTH1:"+authUrl1);
        const windowFeatures = "left=100,top=100,width=500,height=800";
        const popup = window.open(authUrl, "SnapchatAuthenticate", windowFeatures);
        const pollTimer = setInterval(() => {
            if (!popup || popup.closed) {
                clearInterval(pollTimer);
                if (!formik.values[formikField]) {
                    formik.setFieldTouched(formikField, true, false);
                    formik.setFieldError(formikField, "Access is required");
                }
            }
        }, 500);
    }
}

export const putCheck = (e, value, formikField, formik) => {
    //return formik?.values?.[formikField].includes(value);
    if (e.target.checked) {
        formik.setFieldValue(formikField, value);
    } else {
        formik.setFieldValue(formikField, !value);
    }

    return formik?.values?.[formikField];
};
export const putCheckWithObject = (object, objectKey, formikField, formik) => {
    return formik?.values?.[formikField].find(
        (i) => i[objectKey] === object[objectKey]
    );
};

export const handleCheckboxChangeWithObject = (
    e,
    object,
    objectKey,
    formikField,
    formik,
    getCheckboxValue
) => {
    const {checked} = e.target;
    if (checked) {
        formik.setFieldValue(formikField, [...formik.values[formikField], object]);
        if (formik.values[formikField].length === 0) {
            getCheckboxValue(object.segment_name, object.id);
        }
    } else {
        formik.setFieldValue(
            formikField,
            formik.values[formikField].filter(
                (v) => v[objectKey] !== object[objectKey]
            )
        );
        if (formik.values[formikField].length === 2) {
            if (object.segment_name !== formik.values[formikField][0].segment_name) {
                getCheckboxValue(
                    formik.values[formikField][0].segment_name,
                    formik.values[formikField][0].id
                );
            } else {
                getCheckboxValue(
                    formik.values[formikField][1].segment_name,
                    formik.values[formikField][1].id
                );
            }
        }
    }
};

export const signOut = async () => {
    try {
        await semcastAxios.get(SIGN_OUT_API, {withCredentials: true});
        removeDataFromStorage();

        // reset login attempts cookie
        // document.cookie = "attempts=0";
        // sessionStorage.setItem("attempts",0)
        let attemptRes = semcastAxios.post(LOGIN_ATTEMPT_API, {data:0},{withCredentials: true});
        window.location.href = "/"
        // history.push("/");
    } catch (e) {
    }
}

export const signInAs = async (id) => {
    const res = await semcastAxios.get(LOGIN_AS + id, {
        withCredentials: true,
    });
    if (res.data.status === SUCCESS_STATUS)
        window.location.href = "/segmentation-dashboard";
};

export const sortItemsByField = (
    items,
    sortedField,
    sortOrder = ASCENDING_ORDER
) => {
    if (sortedField !== null) {
        items.sort((a, b) => {
            if (
                (a[sortedField] + "").toLowerCase() <
                (b[sortedField] + "").toLowerCase()
            ) {
                return sortOrder === ASCENDING_ORDER ? -1 : 1;
            }
            if (
                (a[sortedField] + "").toLowerCase() >
                (b[sortedField] + "").toLowerCase()
            ) {
                return sortOrder === ASCENDING_ORDER ? 1 : -1;
            }
            return 0;
        });
    }
};

export const paginationCustomTotal = (from, to, size) => (
    <span className="ml-3 react-bootstrap-table-pagination-total">
    Showing {from} to {to} of {size}
  </span>
);
export const paginationOptions = (rows) => {
    return {
        paginationSize: 4,
        //pageStartIndex: 0,
        // alwaysShowAllBtns: true, // Always show next and previous button
        // withFirstAndLast: false, // Hide the going to First and Last page button
        // hideSizePerPage: true, // Hide the sizePerPage dropdown always
        // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        /*  firstPageText: 'First',
                prePageText: 'Back',
                nextPageText: 'Next',
                lastPageText: 'Last',
                nextPageTitle: 'First page',
                prePageTitle: 'Pre page',
                firstPageTitle: 'Next page',
                lastPageTitle: 'Last page',*/
        showTotal: true,
        paginationTotalRenderer: paginationCustomTotal,
        //disablePageTitle: true,
        sizePerPageList: [
            {
                text: "10",
                value: 10,
            },
            {
                text: "20",
                value: 20,
            },
            {
                text: "50",
                value: 50,
            },
            {
                text: "100",
                value: 100,
            },
            {
                text: "All",
                value: rows?.length,
            },
        ], // A numeric array is also available. the purpose of above example is custom the text
    };
};

export const noDataIndication = () => {
    return NO_DATA_TO_SHOW;
};
export const exportCSVOptions = () => {
    return {
        fileName: ADMIN_SETUP_DOWNLOADED_CSV_FILE_NAME,
    };
};
export const boostrap2TableSearchOptions = () => {
    return {};
};
export const ExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        // <div className="d-flex justify-content-end align-items-center float-right">
            <a
                href="javascript:void(0)"
                className="btn btn-primary float-right"
                title="CSV"
                onClick={handleClick}
            >
                <i className="fa fa-arrow-down"></i>CSV
            </a>
        // </div>
    );
};
export const defaultSortedOnTotal = [
    {
        dataField: "total",
        order: "desc",
    },
];

// =========== TABLE COLUMN  FORMATTERS START==============
export const emailFormatter = (cell, row) => {
    try {
        if (cell) {
            return (
                <a href={`mailto:${cell}`} target="_blank" rel="noreferrer">
                    {cell}
                </a>
            );
        }
    } catch (e) {
        console.log(e);
        return <></>;
    }
};

export const loginColumnFormatter = (cell, row) => {
    try {
        return (
            <a
                href="javascript:void(0)"
                className="btn btn-primary shadow btn-xs sharp mr-1"
                onClick={() => signInAs(cell)}
            >
                <i className="fa fa-sign-in"/>
            </a>
        );
    } catch (e) {
        console.log(e);
        return <></>;
    }
};
export const errorColumnFormatter = (cell, row) => {
    try {
        return <span className="text-danger">{cell}</span>;
    } catch (e) {
        console.log(e);
        return <></>;
    }
};

export const progressbarFormatter = (cell, row) => {
    try {
        if (cell === 0 || cell) {
            return (
                <ProgressBar
                    animated
                    variant="info" /*label={`${row?.overall_percent}%`}*/
                    now={cell}
                />
            );
        }
    } catch (e) {
        console.log(e);
        return <></>;
    }
};

export const dateFormatter = (
    cell,
    row,
    FORMAT = YYYY_MM_DD_H_MM_SS_A_DATEFORMAT
) => {
    try {
        if (cell) {
            return <>{moment(cell).format("YYYY-MM-DD h:mm:ss A")}</>;
        }
    } catch (e) {
        console.log(e);
        return <></>;
    }
};

// =========== TABLE COLUMN  FORMATTERS  END ==============

// =========== TABLE COLUMN CUSTOM FILTER VALUES  START ==============

/*export const emailCellFilterValue =(cell, row) => {
    try {
        return cell?.split("@")[0]
    } catch (e) {
        return ""
    }
}*/

// =========== TABLE COLUMN CUSTOM FILTER VALUES END ==============

export const priceFormat = (price, currency = UDX.currencyCodes.USD) => {
    try {
        return (
            currency +
            price.toLocaleString(navigator.language, {minimumFractionDigits: 2})
        );
    } catch (e) {
        return currency + "0.00";
    }
};

export function formatDateToString(date) {
    const format = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = `${d.getMonth() + 1}`.padStart(2, '0');
        const day = `${d.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return format(date);
}


// Adds suffixes for day numbers (1st, 2nd, 3rd, 4th, ...)
function ordinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

// Accepts a schedule object and returns a human-readable string
export function formatSchedule(schedule) {
    if (!schedule || !schedule.type) return "";

    switch (schedule.type) {
        case "DAILY":
            return "Daily";
        case "WEEKLY":
            return `Weekly on ${schedule.dayOfWeek || "?"}`;
        case "MONTHLY":
            return `Monthly on ${schedule.dayOfMonth ? ordinal(schedule.dayOfMonth) : "?"}`;
        default:
            return schedule.type;
    }
}
